"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAuthSignUpUrl = void 0;
const _enums_1 = require("../../../types/@enums");
const AppEnvConfig_1 = require("../../../AppEnvConfig");
const utils_1 = require("../../../utils");
const constants_1 = require("../../constants");
const businessUnit = utils_1.envToBusinessUnit[constants_1.CURRENT_BRAND];
const buildAuthSignUpUrl = (catalogSlug, subpath) => {
    const { origin } = window.location;
    const config = AppEnvConfig_1.AppEnvConfig.getConfig();
    const resellerSlug = catalogSlug || utils_1.envConfig.genericUrl;
    const authParams = {
        page_id: 'menu_mld_login',
        reseller_slug: resellerSlug,
        redirect_uri: `${origin}/${resellerSlug}/area-do-consumidor` + (subpath || ''),
        authenticate: 'true',
    };
    const businessUnitParsed = businessUnit === _enums_1.BusinessUnit.MLT ? '' : businessUnit;
    const baseUrl = `${config.AUTH_CUSTOMER_API_URL}${constants_1.AUTH_SIGNUP_PATH}/${businessUnitParsed}`;
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(authParams)) {
        params.append(key, value);
    }
    return `${baseUrl}?${params.toString()}`;
};
exports.buildAuthSignUpUrl = buildAuthSignUpUrl;
